export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 120 },
  // { key: '2', headerName: 'code', field: 'code', hide: false, width: 190 },
  { key: '3', headerName: 'Vendor Type', field: 'vendor_type', hide: false, width: 200 },
  { key: '4', headerName: 'Service For', field: 'service_for', hide: false, width: 200 },
  { key: '5', headerName: 'Vendor For', field: 'vendor_for', hide: false, width: 200 },
  { key: '6', headerName: 'Vendor Code', field: 'vendor_code', hide: false, width: 200 },
  { key: '7', headerName: 'Name', field: 'name', hide: false, width: 200 },
  { key: '8', headerName: 'Payment Terms', field: 'payment_terms', hide: false, width: 200 },
  { key: '9', headerName: 'Pan Number', field: 'pan_number', hide: false, width: 200 },
  { key: '10', headerName: 'Type Of Service', field: 'type_of_service', hide: false, width: 200 },
  { key: '11', headerName: 'Rate Of Tds', field: 'rate_of_tds', hide: false, width: 200 },
  { key: '12', headerName: 'Msme Number', field: 'msme_number', hide: false, width: 200 },
  { key: '13', headerName: 'Phone Number', field: 'phone_number', hide: false, width: 200 },
  { key: '14', headerName: 'Mail Id', field: 'mail_id', hide: false, width: 200 },
  { key: '15', headerName: 'Status', field: 'status', hide: false, width: 100 }


  // { key: '4', headerName: 'Category', field: 'auditcategory_name', hide: false, width: 160 },
  // { key: '5', headerName: 'Status', field: 'status', hide: false, width: 100 },
];
